import React, {Component} from 'react';
import PropTypes from 'prop-types';
import { reduxForm } from 'redux-form';
import asyncValidate from './asyncValidate';
import FormFieldsClientsTabsTabIntakeAssessment from 'components/form-fields-clients-tabs/tab-intake-assessment/tab-intake-assessment';
class EditViewPostDischargeTabIntakeAssessment extends Component {
  render() {    
    return (
      <div>
        <FormFieldsClientsTabsTabIntakeAssessment
          {...this.props}
          locked={this.props.locked}
          programSelected={this.props.programSelected}
        />        
      </div>
    );
  }
}
EditViewPostDischargeTabIntakeAssessment.propTypes = {
  locked: PropTypes.bool,
  programSelected: PropTypes.string,
}
EditViewPostDischargeTabIntakeAssessment = reduxForm({
  form: 'PostDischargeEditForm', // a unique name for this form
  asyncValidate,
  destroyOnUnmount: false, // <------ preserve form data
  forceUnregisterOnUnmount: true, // <------ unregister fields on unmount
})(EditViewPostDischargeTabIntakeAssessment);
export default EditViewPostDischargeTabIntakeAssessment;